import React from 'react';
import { PrimeInfoBanner } from './PrimeInfoBanner';
import { Body, DiamondIcon } from '@edreamsodigeo/prisma-design-system';
import {
  useFlow,
  useTranslation,
  createFeature,
} from '@edreamsodigeo/frontend-core';
import {
  PRIME_FIRST_PHASE_1,
  PRIME_FIRST_PHASE_2_MOBILE,
} from '@/versionedComponents';

export const PFPrimeInfoBanner = () => {
  const { t } = useTranslation();
  const flow = useFlow();
  return (
    <PrimeInfoBanner icon={<DiamondIcon color="brandSecondary" size="tiny" />}>
      <Body type={flow === 'mobile' ? 'xSmall' : 'normal'} color="white">
        {t('pricefreeze.summaryPage.infoBanner.exclusivePrime')}
      </Body>
    </PrimeInfoBanner>
  );
};

const VersionedPrimeInfoBannerPhase1 = createFeature({
  name: PRIME_FIRST_PHASE_1,
  variations: [PFPrimeInfoBanner, null],
  version: 1,
});

export const VersionedPrimeInfoBanner = createFeature({
  name: PRIME_FIRST_PHASE_2_MOBILE,
  variations: [VersionedPrimeInfoBannerPhase1, null, null],
  version: 1,
});
